import Api from './api';

// Reversão de unificações de login feitas com o gov.br. Liberada só para os IDs de usuário configurados na API
// (GovUnificationRevert:AllowedUserIds); a API recusa os demais com 403.

// true/false: o usuário logado está na lista de liberados? Qualquer falha conta como "sem acesso".
export const hasAccess = async () => {
  try {
    const res = await Api.get('/gov-unification-revert/access');
    return res?.data?.data === true;
  } catch (e) {
    return false;
  }
};

// POST: o e-mail vai no corpo, não na URL (logs de acesso, histórico do navegador).
export const findCases = async (email) =>
  await Api.post('/gov-unification-revert/cases', { email });

export const revert = async (deletedUserId, principalUserId) =>
  await Api.post('/gov-unification-revert', { deletedUserId, principalUserId });
